export default "__VITE_ASSET__6m2YYmc___"